import React from 'react';
import PropTypes from 'prop-types';
import ProductList from '../ProductList';
import { TmntText } from '../../Common/Text';
import { ProductType, TextPairType } from '../props';

const OrderItemTextType = PropTypes.shape({
  sku: TextPairType,
  storeItemNumber: TextPairType,
  finalSaleMessage: TextPairType,
});

/**
 * ReturnExchangeItemsContainer Component
 *
 * Displays a list of return/exchange items on the return/exchange page.
 */
export default function ReturnExchangeItemsContainer({
  items,
  headerText,
  subHeaderText,
  returnExchangeText,
  text,
}) {
  if (!items?.length) {
    return null;
  }

  const orderProducts = items.map((item) => ({
    ...item,
    product: {
      ...item.product,
      price: item.price,
      formattedPrice: item.formattedPrice,
    },
    isReturnExchangeView: true,
    returnReason: item.returnReason,
    isExchange: item.isExchange,
    returnExchangeText,
    text,
  }));

  return (
    <section className="returned-items-list_wrap">
      {headerText && (
        <h3 className="h3 returned-items_header">
          {typeof headerText === 'object' ? <TmntText tmnt={headerText} /> : headerText}
        </h3>
      )}
      {subHeaderText && (
        <div className="returned-items_sub-header">
          {typeof subHeaderText === 'object' ? <TmntText tmnt={subHeaderText} /> : subHeaderText}
        </div>
      )}
      <ProductList
        orderProducts={orderProducts}
      />
    </section>
  );
}

ReturnExchangeItemsContainer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    product: ProductType.isRequired,
    isExchange: PropTypes.bool,
    returnReason: PropTypes.string,
    price: PropTypes.string,
    formattedPrice: PropTypes.string,
    status: PropTypes.string,
    departmentName: PropTypes.string,
    orderLineKey: PropTypes.string,
  })).isRequired,
  headerText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subHeaderText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  returnExchangeText: PropTypes.shape({
    return: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    exchange: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  }),
  text: OrderItemTextType,
};

ReturnExchangeItemsContainer.defaultProps = {
  headerText: null,
  subHeaderText: null,
  returnExchangeText: { return: 'Return', exchange: 'Exchange' },
  text: {},
};
